import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { yupResolver } from '@hookform/resolvers/yup'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'

import { Column, Button, Text, Input, Select } from '../src/components'

import { contactTypes } from 'constants/contactTypes'
import { createContact } from 'services/contact'
import { ContactResolver } from 'helpers'

import { useUser } from 'context/user-context'

const defaultValues = { name: '', email: '', type: '', subject: '', message: '' }

const ContactUs = () => {
  const router = useRouter()

  const { user } = useUser()

  const [logged, setLogged] = useState(false)

  const {
    control,
    handleSubmit,
    errors,
    formState: { isSubmitting }
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(ContactResolver),
    defaultValues
  })

  const onSubmit = async data => {
    try {
      await createContact(data)
      router.push('/agradecemos-contato')
    } catch (error) {
      toast.error('Ocorreu um erro ao entrar em contato. Tente novamente.')
    }
  }

  useEffect(() => {
    if (!!user) {
      setLogged(true)
    }
  }, [user, setLogged])

  return (
    <Column alignItems='center' width='100%' pt={logged ? '152px' : '112px'} pl={2} pr={2}>
      <NextSeo title='Kavod Lending - Fale conosco' description='KavodLending | Peer to Peer lending' />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Column>
          <Text variant='h3'>Fale conosco</Text>
          <Input
            mt={4}
            mb='40px !important'
            id='name'
            label='Nome'
            name='name'
            placeholder='Nome'
            control={control}
            error={errors.email}
          />
          <Input
            mb='40px !important'
            id='email'
            label='E-mail'
            name='email'
            placeholder='E-mail'
            control={control}
            error={errors.email}
          />
          <Select
            id='type'
            name='type'
            label='Departamento ou tema'
            control={control}
            options={contactTypes}
            error={errors.type}
            mb='40px !important'
          />
          <Input
            mb='40px !important'
            id='subject'
            label='Assunto'
            name='subject'
            placeholder='Assunto'
            control={control}
            error={errors.subject}
          />
          <Input
            mb='40px !important'
            control={control}
            name='message'
            label='Mensagem'
            multiline
            minRows={3}
            maxRows={10}
            error={errors.message}
          />
          <Button width='100%' mb={4} type='submit' loader={isSubmitting}>
            Enviar
          </Button>
        </Column>
      </form>
    </Column>
  )
}

export default ContactUs
